import Image from 'next/image';
import {SPECIAL_POST_SLUGS} from '../../../../core/entities/columns/constants';

const SPECIAL_POST = [
  {
    title: '就活を知る',
    posts: [
      {
        title: '就活を知る',
        slug: SPECIAL_POST_SLUGS.COLUMN_1,
        imageUrl: '/next-image/columns/thumbnail/special_column_1.jpg',
      },
      {
        title: '英語力を鍛える',
        slug: SPECIAL_POST_SLUGS.COLUMN_2,
        imageUrl: '/next-image/columns/thumbnail/special_column_2.png',
      },
      {
        title: '海外大生の就活攻略法',
        slug: SPECIAL_POST_SLUGS.OVERSEAS,
        imageUrl: '/next-image/columns/thumbnail/special_column_overseas.jpg',
      },
    ],
  },
  {
    title: '自分を高める',
    posts: [
      {
        title: '現役社員のお話',
        slug: SPECIAL_POST_SLUGS.COLUMN_5,
        imageUrl: '/next-image/columns/thumbnail/special_column_5.jpg',
      },
      {
        title: '地頭を鍛えるクイズ集',
        slug: SPECIAL_POST_SLUGS.QUIZ,
        imageUrl: '/next-image/columns/thumbnail/special_column_quiz.jpg',
      },
    ],
  },
  {
    title: '業界を研究する',
    posts: [
      {
        title: '投資銀行研究',
        slug: SPECIAL_POST_SLUGS.COLUMN_6,
        imageUrl: '/next-image/columns/thumbnail/special_column_6.jpg',
      },
      {
        title: 'コンサル研究',
        slug: SPECIAL_POST_SLUGS.COLUMN_7,
        imageUrl: '/next-image/columns/thumbnail/special_column_7.jpg',
      },
      {
        title: '総合商社研究',
        slug: SPECIAL_POST_SLUGS.COLUMN_8,
        imageUrl: '/next-image/columns/thumbnail/special_column_8.jpg',
      },
      {
        title: '外資系メーカー・IT研究',
        slug: SPECIAL_POST_SLUGS.COLUMN_9,
        imageUrl: '/next-image/columns/thumbnail/special_column_9.jpg',
      },
      {
        title: 'エンジニア研究',
        slug: SPECIAL_POST_SLUGS.ENGINEER,
        imageUrl: '/next-image/columns/thumbnail/special_column_9.jpg',
      },
    ],
  },
];

export const SpecialIndex: React.FC = () => {
  return (
    <>
      <h2 className="text-black-1 text-lg font-bold leading border-collapse border-l-8 border-l-primary-1 px-12 py-16 text-left my-12">
        2.&nbsp;&nbsp;特集ページ一覧
      </h2>
      {SPECIAL_POST.map((specialPost) => (
        <>
          <h3 className="text-black-1 text-md font-bold leading border-collapse border-b-[1px] border-b-line p-8 text-left my-12">
            {specialPost.title}
          </h3>
          <div className="flex justify-between flex-wrap">
            {specialPost.posts.map((post) => (
              <div className="flex w-[calc((100%-24px)/2)] mb-16">
                <div className="w-[75px] h-[75px]">
                  <Image
                    src={post.imageUrl}
                    alt={post.title}
                    width={75}
                    height={75}
                    className="object-cover"
                  />
                </div>
                <div className="pl-16 w-[calc(100%-75px)]">
                  <a
                    href={`/special/${post.slug}`}
                    className="text-link font-bold text-base leading hover:underline"
                  >
                    {post.title}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </>
      ))}
    </>
  );
};
